// extracted by mini-css-extract-plugin
module.exports = {"upgradeSubscription":"_1pqpcU","price":"_3HldBp","box":"_3shdDj","submitButton":"YaKees","shipping":"_1CzhaX"};